// extracted by mini-css-extract-plugin
export default {"body":"ReportePresentismoModal_body__uHsjE","gridWrap":"ReportePresentismoModal_gridWrap__tOvWd"};